import { Component, inject } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';

export interface SnackBarSuccessInterFace {
  message: string;
}

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [MatIconModule, MatSnackBarLabel],
  templateUrl: `./snackbar.html`,
  styleUrls: ['./snackbar.css'],
})
export class Snackbar {
  public snackBarVar: SnackBarSuccessInterFace = {
    message: 'Success',
  };
  registry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);
  data = inject(MAT_SNACK_BAR_DATA) as SnackBarSuccessInterFace;

  constructor() {
    if (this.data?.message) {
      this.snackBarVar.message = this.data.message;
    }

    // Pastikan path ke file .svg benar
    this.registry.addSvgIcon(
      'check-circle',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icon/check_circle.svg'),
    );
  }
}
